import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const MERGE_RESOURCE = "merge" as const;
export const MERGE_PREVIEW_OPERATION = "preview" as const;
export const MERGE_PREVIEW_API_PATH = `/v1/${MERGE_RESOURCE}/${MERGE_PREVIEW_OPERATION}` as const;

export type MergePreviewInput =
  paths[typeof MERGE_PREVIEW_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type MergePreviewResponse =
  paths[typeof MERGE_PREVIEW_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export function useMergePreviewQuery({ input, enabled }: { input: MergePreviewInput | null; enabled?: boolean }) {
  return useQuery({
    queryKey: [MERGE_RESOURCE, MERGE_PREVIEW_OPERATION, input],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<MergePreviewResponse>(MERGE_PREVIEW_API_PATH, input);
      return response.data;
    },
    enabled: (enabled ?? true) && input !== null,
  });
}
